import { DialogApi } from "src/store/chat/api";
import { DialogLastMessage, DialogType, MessageType } from "./types";
import avatar_skeleton from "src/assets/images/avatar_skeleton.png";
import event_group_dialog_avatar_default from "src/assets/icons/event_group_chat.svg";

export const applyLongPress = (node: HTMLElement, clickHandler: (e: TouchEvent) => void) => {
  node?.addEventListener("touchstart", (e) => {
    const timer = setTimeout(() => clickHandler(e), 500);
    const touchEndHandler = () => {
      clearTimeout(timer);
      node.removeEventListener("touchend", touchEndHandler);
    };
    node.addEventListener("touchend", touchEndHandler);

    const touchmoveHandler = () => {
      clearTimeout(timer);
      node.removeEventListener("touchmove", touchmoveHandler);
    };
    node.addEventListener("touchmove", touchmoveHandler);
  });
};

const dialogDefaultAvatar = {
  [DialogType.Personal]: avatar_skeleton,
  [DialogType.Group]: event_group_dialog_avatar_default,
};

export const createDialogfromApi = (dialog: DialogApi) => {
  const dlm = dialog.last_message;
  let lastMessage: DialogLastMessage | null = null;
  if (dlm)
    if (dlm.type === MessageType.User)
      lastMessage = {
        type: MessageType.User,
        text: dlm.text,
        username: dlm.username,
        datetime: dlm.datetime,
      };
    else if (dlm.type === MessageType.System)
      lastMessage = {
        type: MessageType.System,
        systemMessageType: dlm.system_metadata.type,
        datetime: dlm.datetime,
      };

  return {
    type: dialog.type,
    system: dialog.system,
    id: dialog.chat_id,
    title: dialog.title,
    avatarUrl: dialog.avatar_url || dialogDefaultAvatar[dialog.type],
    isVerified: true,
    isRead: false,
    isOnline: false,
    isWarning: dlm?.type === MessageType.System,
    isMute: false,
    lastMessage,
    unreadMessagesCount: dialog.unread_messages_count,
    messages: null,
  };
};
